import Vue from 'vue';
import VueRouter from 'vue-router';

import moduleRouters from '@/module/router'
import authPlugin from '@/plugins/auth'

import { crmUrl } from '@/config/customization'

const App = resolve => require(['../App.vue'], resolve);
const Login = resolve => require(['@/components/login/Login.vue'], resolve);
const Main = resolve => require(['@/components/main/Main.vue'], resolve);
const Home = resolve => require(['@/components/home/Home.vue'], resolve);
const Unauthorized = resolve => require(['@/components/401.vue'], resolve);
const NotFound = resolve => require(['@/components/404.vue'], resolve);
const InternalServerError = resolve => require(['@/components/500.vue'], resolve);
const Auth = resolve => require(['@/components/auth.vue'], resolve);  //<!--停止使用-->
const Authorize = resolve => require(['@/components/authorize.vue'], resolve);
const IFrameContainer = resolve => require(['@/components/external/IFrameContainer.vue'], resolve);

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [{
    path: '/login',
    name: 'login',
    meta: {
      keepAlive: true,
      allowAnonymous: true
    },
    component: Login
  },
  {
    path: '/401',
    name: '401',
    component: Unauthorized,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/404',
    name: '404',
    component: NotFound,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/500',
    name: '500',
    component: InternalServerError,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/auth/:userId/:targetUrl',
    name: 'auth',
    component: Auth,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/authorize',
    name: 'authorize',
    component: Authorize,
    meta: {
      allowAnonymous: true
    }
  },
  {
    path: '/',
    redirect: {
      name: 'home'
    },
    meta: {
      keepAlive: true
    },
    component: Main,
    children: [{
      path: 'home',
      name: 'home',
      meta: {
        keepAlive: true
      },
      component: Home
    },
    {
      path: 'external/:url',
      name: 'external',
      component: IFrameContainer
    }]
  },
  ...generateRoutesFromModules(),
  {
    path: '*',
    redirect: '/404'
  }
  ]
})

//注册一个全局的 before 钩子，对于需要登录才能访问的模块进行控制
router.beforeEach((to, from, next) => {
  if (to.meta.allowAnonymous) {
    if (to.name === "auth" || to.name === "authorize") {
      authPlugin.clearAllData();
    }

    next();
    return;
  }

  //针对嵌入到CRM的页面的处理
  if (to.name.contains("crm__")) {
    guardCrmRoute(to, from, next);
    return;
  }

  //针对PORTAL页面的处理
  guardRoute(to, from, next);
});


function generateRoutesFromModules() {
  return moduleRouters;
}

function guardCrmRoute(to, from, next) {
  const auth = router.app.$options.store.state.auth;
  if (!auth.isLoggedIn) {
    var redirectUrl = location.origin + location.pathname + "#/authorize?redirect_url=" + encodeURIComponent(to.path);
    var data = encodeURIComponent("redirect_url=" + encodeURIComponent(redirectUrl));
    //var data = encodeURIComponent("redirect_url=" + encodeURIComponent(to.path));

    window.location.href = crmUrl + '/WebResources/new_/connect/authorize.html?Data=' + data;
  } else {
    next();
  }
}

function guardRoute(to, from, next) {
  //如果是非Portal用户登录产生的auth,直接退出重新登录
  const user = router.app.$options.store.state.user;
  if (user != null && user.loginType != null && user.loginType == 'sso_mscrm') {
    authPlugin.logout();
    return;
  }

  const auth = router.app.$options.store.state.auth;
  if (!auth.isLoggedIn) {
    if (to.name === 'home') {
      next({
        name: 'login'
      });
    } else {
      next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js